import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable ,  of } from 'rxjs';

@Injectable()
export class ModelMapService {

  constructor(private http: HttpClient) { }

  getAllModelMapData(): Observable<any> {
    return this.http.get('model-map/all', { withCredentials: true });
  }
  getAllModels(): Observable<any> {
    return this.http.get('model-map/modelList', { withCredentials: true });
  }
  getAllSeries(): Observable<any> {
    return this.http.get('model-map/seriesList', { withCredentials: true });
  }

  getAllAreas(): Observable<any> {
    //return this.http.get('model-map/seriesList', {withCredentials : true});
    return of([
      { value: 'Body and Trim', viewValue: 'Body and Trim' },
      { value: 'Infotainment', viewValue: 'Infotainment' },
      { value: 'Electrics / Electronics', viewValue: 'Electrics / Electronics' },
      { value: 'Chassis and Suspension', viewValue: 'Chassis and Suspension' },
      { value: 'Powertrain', viewValue: 'Powertrain' }
    ]);
  }

  getSproadicPermanent(): Observable<any> {
    //return this.http.get('model-map/seriesList', {withCredentials : true});
    return of([
      { value: 'Sporadic', viewValue: 'Sporadic' },
      { value: 'Permanent', viewValue: 'Permanent' },
      
    ]);
  }

  getAllDriveConditions(): Observable<any> {
    //return this.http.get('model-map/seriesList', {withCredentials : true});
    return of([
      { value: 'Cold start', viewValue: 'Cold start' },
      { value: 'Acceleration', viewValue: 'Acceleration' },
      { value: 'Constant speed', viewValue: 'Constant speed' },
      { value: 'Braking high speed', viewValue: 'Braking high speed' },
      { value: 'Braking high speed', viewValue: 'Braking high speed' },
      { value: 'Turning', viewValue: 'Turning' },
      { value: 'Parking', viewValue: 'Parking' },
    ]);
  }

  getAllWeatherConditions(): Observable<any> {
    //return this.http.get('model-map/seriesList', {withCredentials : true});
    return of([
      { value: 'Low temperatures (below 40 F)', viewValue: 'Low temperatures (below 40 F)' },
      { value: 'High temperatures (above 40 F)', viewValue: 'High temperatures (above 40 F)' },
      { value: 'Rain', viewValue: 'Rain' },
      { value: 'Snow', viewValue: 'Snow' },
      { value: 'Ice', viewValue: 'Ice' },
    ]);
  }

  getAllKindOfNoises(): Observable<any> {
    //return this.http.get('model-map/seriesList', {withCredentials : true});
    // return of([
    //   { item_id: 'Abnormal', item_text: 'Abnormal' },
    //   { item_id: 'Process', item_text: 'Process' },
    //   { item_id: 'Background', item_text: 'Background' },
    //   { item_id: 'Abnormal1', item_text: 'Abnormal1' },
    //   { item_id: 'Process1', item_text: 'Process1' },
    //   { item_id: 'Background1', item_text: 'Background1' },
    //   { item_id: 'Abnorma2', item_text: 'Abnormal2' },
    //   { item_id: 'Process2', item_text: 'Process2' },
    //   { item_id: 'Background2', item_text: 'Background2' },
    // ]);
    return of([
      { value: 'Rattling', viewValue: 'Rattling' },
      { value: 'Knocking', viewValue: 'Knocking' },
      { value: 'Grinding/Rubbing', viewValue: 'Grinding/Rubbing' },
      { value: 'Squeaking / Squealing', viewValue: 'Squeaking / Squealing' },
      { value: 'Whistling/Hissing', viewValue: 'Whistling/Hissing' },
      { value: 'Humming/Drone', viewValue: 'Humming/Drone' },
      { value: 'Cracking / Creaking', viewValue: 'Cracking / Creaking' },
      { value: 'Clicking', viewValue: 'Clicking' },
      { value: 'Buzzing', viewValue: 'Buzzing' },
    ]);
  }

  getAllEngines(): Observable<any> {
    return this.http.get('model-map/engineList', {withCredentials : true});
  }
  getAllYears(): Observable<any> {
    return this.http.get('model-map/yearList', {withCredentials : true});
  }
  getAllCodes(): Observable<any> {
    return this.http.get('model-map/codeList', {withCredentials : true});
  }
  getAllDefectCodes(): Observable<any> { 
    return this.http.get('model-map/defectCodesList', {withCredentials : true});
  }
  getAllFaultCodes(): Observable<any> { 
    return this.http.get('model-map/faultCodesList', {withCredentials : true});
  }

  getAllComponent(): Observable<any> {
    //return this.http.get('model-map/seriesList', {withCredentials : true});
    return of([
      { value: 'Steering gear', viewValue: 'Steering gear' },
      { value: 'Steering column', viewValue: 'Steering column' },
      { value: 'Stabilizer links', viewValue: 'Stabilizer links' },
      { value: 'Suspension links', viewValue: 'Suspension links' },
      { value: 'Struts ', viewValue: 'Struts' },
      { value: 'Wheel bearings', viewValue: 'Wheel bearings' },
      { value: 'Wheels', viewValue: 'Wheels' },
      { value: 'Brake pads', viewValue: 'Brake pads' },
      { value: 'Brake rotors', viewValue: 'Brake rotors' },
      { value: 'Parking brake', viewValue: 'Parking brake' },
      { value: 'DSC', viewValue: 'DSC' },
      { value: 'EMF', viewValue: 'EMF' },
      { value: 'Window', viewValue: 'Window' },
      { value: 'Glass', viewValue: 'Glass' },
      { value: 'Body', viewValue: 'Body' },
      { value: 'Sunroof', viewValue: 'Sunroof' },
      { value: 'Door ', viewValue: 'Door' },
      { value: 'Seats', viewValue: 'Seats' },
      { value: 'Interior trim', viewValue: 'Interior trim' },
      { value: 'Dashboard', viewValue: 'Dashboard' },
      { value: 'Valve lifters', viewValue: 'Valve lifters' },
      { value: 'Pistons/Rings', viewValue: 'Pistons/Rings' },
      { value: 'Ignition', viewValue: 'Ignition' },
      { value: 'Injectors ', viewValue: 'Injectors ' },
      { value: 'Timing chain/Tensioner', viewValue: 'Timing chain/Tensioner' },
      { value: 'Belt drive/Pulleys/Belt tensioner', viewValue: 'Belt drive/Pulleys/Belt tensioner' },
      { value: 'Water pump', viewValue: 'Water pump' },
      { value: 'Vacuum pump', viewValue: 'Vacuum pump' },
      { value: 'Oil pump/Chain', viewValue: 'Oil pump/Chain' },
      { value: 'Alternator', viewValue: 'Alternator' },
      { value: 'Turbocharger/Wastegate actuators ', viewValue: 'Turbocharger/Wastegate actuators' },
      { value: 'Crankshaft/main bearings/conrod bearings', viewValue: 'Crankshaft/main bearings/conrod bearings' },
      { value: 'Crank ventilation system (TEV valve)', viewValue: 'Crank ventilation system (TEV valve)' },
      { value: 'Clutch/Bearing/Flywheel', viewValue: 'Clutch/Bearing/Flywheel' },
      { value: 'Transmission/Torque converter', viewValue: 'Transmission/Torque converter' },
      { value: 'Driveshaft/Flexible discs', viewValue: 'Driveshaft/Flexible discs' },
      { value: 'Transfer case', viewValue: 'Transfer case' },
      { value: 'Differential (gears and limited slip components)', viewValue: 'Differential (gears and limited slip components)' },
      { value: 'Fuel tank/Fuel pump', viewValue: 'Fuel tank/Fuel pump' },
      { value: 'Springs and shocks', viewValue: 'Springs and shocks' },
      { value: 'Engine/Transmission mounts (hydraulic and vacuum)', viewValue: 'Engine/Transmission mounts (hydraulic and vacuum)' },
      { value: 'Shifter (mechanical)', viewValue: 'Shifter (mechanical)' },
      { value: 'High Voltage Compressor', viewValue: 'High Voltage Compressor' },
      { value: 'eMachine / transmission noises (bearings)', viewValue: 'eMachine / transmission noises (bearings)' },
      { value: 'REx Engine / REx Generator', viewValue: 'REx Engine / REx Generator' },
      { value: 'Cooling Fan', viewValue: 'Cooling Fan' },
      { value: 'PHEV: eMachine during regeneration when HV battery is almost depleted', viewValue: 'PHEV: eMachine during regeneration when HV battery is almost depleted' },
    ]);
  }

}
